import React from 'react'
import { withTranslation } from 'react-i18next'

import icon_addText from '../i/add_text.svg'
import icon_addImg from '../i/add_img.svg'
import icon_addButton from '../i/add_cta.svg'
import icon_more from '../i/more.svg'

const Add = ({ onAdd, onOpenBlockPane, openAssetManager, t }) => {
    return (
        <ul className="quick-add-list">
            <span className="quick-add-list__button" onClick={() => onAdd(1)}>
                <img src={icon_addText} alt="" />
                {t('Add text')}
            </span>
            <span
                className="quick-add-list__button"
                onClick={() => openAssetManager(data => onAdd(2, null, { url: data.src }))}
            >
                <img src={icon_addImg} alt="" />
                {t('Add image')}
            </span>
            <span className="quick-add-list__button" onClick={() => onAdd(6)}>
                <img src={icon_addButton} alt="" />
                {t('Add button')}
            </span>
            <span className="quick-add-list__button quick-add-list__button--blue" onClick={() => onOpenBlockPane()}>
                <img src={icon_more} alt="" />
                {t('All blocks')}
            </span>
        </ul>
    )
}

export default withTranslation('translations')(Add)
